export default {
  app: {
    name: 'EONLAND',
  },
  language: {
    local: 'English',
    chinese: '中文（简体）',
    english: 'English',
  },
  login: {
    email: 'Email',
    username: 'username',
    password: 'Password',
    login: 'Login',
    emailReg: 'Please enter email',
    emailCorrectReg: 'Please enter correct email',
    usernameReg: 'Please enter username',
    passwordReg: 'Please enter password',
    countryReg: 'Please select country',
    loginSuccess: 'Login Successfully',
    appDownload: 'App Download',
    welcomeTo: 'Welcome To',
    signIn: 'Login',
    rememberPassword: 'Remember me',
    forgotPassword: 'Forgot password?',
    forgotPassword2: 'Forgot password',
    createAccount: 'Create a new account',
    aboutUs: 'About Us',
    contactUs: 'Contact Us',
    privacyPolicy: 'Privacy Policy',
    termsOfUse: 'Terms of Use',
    termsOfUsePrivacyPolicy: 'Terms of Use & Privacy',
    copyRight: 'Copyright © 2022-{year} {company}',
    logout: 'Logout',
    scanLogin: 'Scan Login',
    open: 'Open',
    app: 'APP',
    openScanLogin: 'Scan Login',
    emailLogin: 'Email Login',
    codeExpired: 'QR Code Expired',
    capsLockTurnedOn: 'Caps lock turned on',
    EONPowerlandApp: '{sysName} APP',
    refreshQrcode: 'Refresh',
  },
  home: {
    selectLanguage: 'Language',
    overview: 'Home',
    plant: 'Plant',
    device: 'Device',
    user: 'User',
    log: 'Log',
    admin: 'Admin',
    inverter: 'Inverter',
    plantDetail: 'Plant Detail',
    organization: 'Organization',
    firmware: 'Firmware',
    operation: 'Operation',
    instruction: 'Instruction',
    gridProfile: 'Grid Profile',
    orgAndUser: 'Org & User',
    addPlant: 'Add Plant',
    fault: 'Event',
    faultConfig: 'Fault Config',
    agencyUpdateMessage: 'The permissions of the organization have changed. Please login again',
    userDeleteMessage: 'The current user has been deleted. Please change your account and login again or create a new one',
  },
  request: {
    timeout: 'Request timeout',
    networkError: 'Network error, please try again',
    serverError: 'Server error',
    loginExpires: 'Login expires',
  },
  overviews: {
    totalSize: 'Total Capacity',
    realTimePower: 'Real Time Power',
    kw: 'kW',
    kwh: 'kWh',
    mwh: 'MWh',
    dailyYield: 'Daily Yield',
    monthlyYield: 'Monthly Yield',
    yearlyYield: 'Yearly Yield',
    totalYield: 'Total Yield',
    income: 'Revenue',
    dailyIncome: 'Daily Revenue',
    currencyUnit: '$',
    ton: 't',
    kg: 'kg',
    CO2EmissionReduction: 'CO₂ emission reduction',
    plants: 'Plants',
    totalInverter: 'Total Microinverters',
    onlineInverters: 'Online Microinverters',
    totalPCS: 'Total PCS',
    totalPowerSensor: 'Total Meter',
    home: 'Home',
    pv: 'PV',
    toGrid: 'To Grid',
    discharge: 'Discharge',
    charge: 'Charge',
    day: 'Day',
    month: 'Month',
    year: 'Year',
    all: 'All',
    lifetime: 'Total',
    pickAYear: 'Pick a year',
    selfUse: 'Self-Use',
    feedInEnergy: 'Feed-in Energy',
    feedOutEnergy: 'Feed-out Energy',
    powerGeneration: 'Power Generation',
    powerConsumption: 'Power Consumption',
    fromGrid: 'From Grid',
    electricityManagement: 'Electricity Management',
    electricityPrice: 'Electricity Price',
    monetaryUnit: 'Monetary Unit',
    monetaryUnitReg: 'Please select monetary unit',
    coefficientReg: 'Please enter electricity price',
    coefficientCorrectReg: 'Please enter the correct electricity price',
    period: 'Period',
    startTimeReg: 'Please select start time',
    endTimeReg: 'Please select end time',
    startTime: 'Start Time',
    endTime: 'End Time',
  },
  plant: {
    inverterSN: 'Inverter SN',
    plantName: 'Plant Name',
    ownerEmail: 'Owner Email',
    originalOwnerEmail: 'Original Owner Email',
    registrationNO: 'Plant ID',
    status: 'Online Status',
    country: 'Country/Region',
    type: 'Type',
    place: 'Full Address',
    timeZone: 'TimeZone',
    lon: 'Lon',
    lat: 'Lat',
    address: 'Full Address',
    images: '',
    drag: 'Drag the file here,or',
    or: 'or',
    click: 'Click to Upload',
    only: 'Only jpg/png/jpeg/bmp files can be uploaded',
    uploading: 'Uploading...',
    imageReg: 'The upload format is incorrect. Please upload jpg/png/jpeg/bmp format',
    fileReg: 'Picture size should not exceed 5MB!',
    plantNameReg: 'Please enter plantName',
    addDevice: 'Add Device',
    ratedGatewaySNReg: 'Please enter gatewaySN',
    addDeviceSN: 'Add Device',
    delete: 'Delete',
    deleteReminder: 'Unbinding the gateway will unbinding other devices associated with the current gateway from the plant!',
    addGateway: 'Add Gateway',
    unbindDevice: 'Unbind Device',
    unbindGateway: 'Unbind Gateway',
    addGatewayMsg: 'Please add a gateway first',
    gatewaySN: 'Gateway SN',
    plantRelationShip: 'Plant Chart',
    emailVerification: 'Email Verification',
    plantEditConfirm: 'Modifying the country or modifying owner email may cause updates to its grid profile. Are you sure to make the changes?',
    message: 'Message',
    upgradeMesg: 'The new firmware version has been released!',
    dailyLoad: 'Daily Load',
    dailyToGrid: 'Daily ToGrid',
    dailyFromGrid: 'Daily FromGrid',
    acPower: 'PV',
    Pload: 'Home',
    PGridMeter: 'Grid',
    PBatBMS: 'Energy Storage',
    upgradeMode: 'Microinverter Upgrade Mode',
    upgradeModeReg: 'Please select upgrade mode',
  },
  device: {
    deviceSN: 'Device SN',
    deviceType: 'Device Type',
    deviceModel: 'Device Model',
    plant: 'Plant',
    deviceName: 'Device Name',
    loginAccount: 'Login Account',
    batchImport: 'Batch Import',
    batchDelete: 'Batch Delete',
    batchExport: 'Batch Export',
    batchEdit: 'Batch Edit',
    expireDate: 'Expire Date',
    firmwareVersion: 'Firmware Version',
    hardwareVersion: 'Hardware Version',
    deviceSNReg: 'Please enter device SN',
    deviceSNExceed: 'Device SN exceeds 50 characters',
    deviceSNCorrectReg: 'Device SN only supports digits and letters',
    deviceNameReg: 'Please enter device name',
    deviceNameExceed: 'Device name exceeds 50 characters',
    deviceTypeReg: 'Please select device type',
    deviceTypeEnterReg: 'Please enter device type',
    deviceTypeEnterCorrectReg: 'Please enter the correct device type',
    deviceModelReg: 'Please enter device model',
    deviceModelExceed: 'Device model exceeds 50 characters',
    ratedPowerReg: 'Please enter capacity',
    ratedPowerCorrectReg: 'Please enter the correct capacity',
    ratedPowerDigitReg: 'Capacity can be up to 8 digits before the decimal point and up to 3 digits after the decimal point',
    powerReg: 'Please enter power',
    powerCorrectReg: 'Please enter the correct power',
    powerDigitReg: 'Power can be up to 8 digits before the decimal point and up to 3 digits after the decimal point',
    expireDateReg: 'Please select expire date',
    expireDateEnterReg: 'Please enter expire date',
    expireDateEnterCorrectReg: 'Please enter the correct expire date',
    hardwareVersionReg: 'Please enter hardware version',
    hardwareVersionCorrectReg: 'Please enter the correct hardware version, 0.0.0 ~ 255.255.255',
    hardwareVersionCorrectReg2: 'Please enter the correct hardware version, V0.0.0 ~ V255.255.255',
    firmwareVersionCorrectReg: 'Please enter the correct firmware version, 0.0.0 ~ 255.255.255',
    firmwareVersionCorrectReg2: 'Please enter the correct firmware version, V0.0.0 ~ V255.255.255',
    statusReg: 'Please select status',
    statusEnterReg: 'Please enter status',
    statusEnterCorrectReg: 'Please enter this correct status',
    plantRegistrationNO: 'Plant ID',
    downloadBatchImportTemplate: 'Download template',
    agencyNoExistError: 'Agency number does not exist, please check',
    macReg: 'Please enter MAC',
    macCorrectReg: 'Please enter the correct MAC address in the format of xx:xx:xx:xx:xx:xx:xx',
    microInverterParameterSet: 'Microinverter Parameter Set',
    gatewayParameterSet: 'Gateway Parameter Set',
    workingStatus: 'Working Status',
    atLeastOneModified: 'At least one item needs to be modified',
    selectFileUpload: 'Select File Upload',
    select: 'Select',
    incompleteUpgrades: 'Incomplete Upgrades',
    upgradedInfo: 'Upgraded Info',
    COperMode: 'COperMode',
    CFunc: 'CFunc',
    CProtect: 'CProtect',
    CSOutLimit: 'CSOutLimit',
    CSInLimit: 'CSInLimit',
    CPOutLimit: 'CPOutLimit',
    CPInLimit: 'CPInLimit',
    CPerOutLimit: 'CPerOutLimit',
    CPerInLimit: 'CPerInLimit',
    CQpLimit: 'CQpLimit',
    CQnLimit: 'CQnLimit',
    CLormsLimit: 'CLormsLimit',
    CPSet: 'CPSet',
    CQSet: 'CQSet',
    CPFSet: 'CPFSet',
    CSafety: 'CSafety',
    CTransPeriod: 'CTransPeriod',
    CRecordTime: 'CRecordTime',
    sureRestore: 'Do you want to restore factory settings ',
    sureRestart: 'Do you want to restart ',
    sureStartDebug: 'Do you want to start debug',
    CldUpdPeriod: 'CldUpdPeriod',
    selectTime: 'Please select the time first',
    cldUpdPeriodReg: 'Greater than or equal to 60 seconds',
    cancelUpgradeFailed: 'Microinverter %s cancel upgrade failed',
    upgradeTimeout: 'Timeout',
    reportModelDiff: 'Different from the reported device model (XXX)',
  },
  fault: {
    status: 'Status',
    faultCode: 'Fault Code',
    alarmName: 'Alarm Name',
    alarmLevel: 'Alarm Level',
    occurrenceTime: 'Start time',
    recoveryTime: 'End time',
    faultReason: 'Fault Reason',
    processingRecommendations: 'Processing Recommendations',
    emailPush: 'Email Push',
    isCover: 'Is Cover',
    alarmNameReg: 'Please enter alarmName',
    faultCodeReg: 'Please enter faultCode',
    dispose: 'Processed',
  },
  user: {
    userRole: 'User Role',
    email: 'Email',
    phone: 'Phone',
    comment: 'Comment',
    lastLoginTime: 'Last Login Time',
    organizationNo: 'Organization No.',
    organizationName: 'Organization Name',
    organizationLevel: 'Agent Level',
    superiorOrganization: 'Superior Agent',
    superiorOrganizationNo: 'Superior Agent No.',
    superiorOrganizationName: 'Superior Agent Name',
    organizationType: 'Organization Type',
    contact: 'Contact',
    country: 'Country/Region',
    userAdd: 'Add User',
    userEdit: 'Edit User',
    userRoleReg: 'Please select user role',
    emailReg: 'Please enter email',
    emailCorrectReg: 'Please enter correct email',
    passwordReg: 'Please enter password',
    passwordCorrectReg: 'Enter 6~30 characters',
    countryReg: 'Please select country and region',
    addressReg: 'Please enter full address',
    organizationReg: 'Please select organization',
    confirmPasswordReg: 'Please enter confirm password',
    confirmPasswordCorrectReg: 'The passwords do not match',
    oldPasswordMatchReg: 'The password can\'t be the same as the old password',
    password: 'Password',
    confirmPassword: 'Confirm Password',
    installer: 'Installer',
    primaryAgent: 'Primary Agent',
    secondaryAgent: 'Secondary Agent',
    thirdLevelAgent: 'Third Level Agent',
    fourthLevelAgent: 'Fourth Level Agent',
    fifthLevelAgent: 'Fifth Level Agent',
    organizationNoReg: 'Please enter agent number',
    organizationNoCorrectReg: 'Agent number only supports digits and letters',
    organizationNameReg: 'Please enter agent name',
    isInstallerReg: 'Please select whether it is an installer',
    authCodeReg: 'Please enter verification code',
    authCodeCorrectReg: 'Please enter correct verification code',
    verificationCode: 'Verification code',
    i_agree: 'I agree to the ',
    terms_of_use: 'Terms of Use',
    i_have_red: ' and I have read the ',
    i_have_read_and_agree: 'I have read and agree to the ',
    privacy_policy: 'Privacy Policy.',
    terms_of_use_privacy_policy: 'Terms of Use & Privacy',
    isCheckReg: 'Please check',
    editPassword: 'Edit Password',
    versionInfo: 'Version Information',
    oldPassword: 'Old Password',
    oldPasswordReg: 'Please enter old password',
    installerNotify: 'If set to installer, it will have no sub-agents',
    preAgencyIdReg: 'Please select Superior Agent',
    editPersonInfo: 'Edit Person Info',
    personInfo: 'Person Info',
    sureToAddUser: 'Do you want to add users immediately',
    organizationChart: 'Organization Chart',
    domain: 'Domain',
    allowLoginMain: 'Domain Allows Login',
    companyZh: 'Chinese name of company',
    companyEn: 'English name of company',
    addressZh: 'Company Chinese Address',
    addressEn: 'Company English Address',
    emailLogo: 'Email Logo',
    user: 'Email Account',
    host: 'Email Server',
    port: 'Email Server Port',
    loginLogo: 'Login Page Logo',
    webLogo: 'Main Page Logo',
    appLogo: 'APP Donload Page Logo',
    webSiteEn: 'English Official Website',
    webSiteZh: 'Chinese Official Website',
    webSiteCorrectReg: 'Enter a correct website that starts with http:// or https://',
  },
  log: {
    operator: 'Operator',
    log: 'Log',
  },
  inverter: {
    inverter: 'Inverter',
    registrationNO: 'Plant ID',
    lastUpdated: 'Last Updated',
    colon: ':',
    acPower: 'AC Power',
    dailyYield: 'Daily Produced',
    totalYield: 'Total Produced',
    pvPower: 'PV Power',
    energyDiagram: 'Energy Diagram',
    pv1Voltage: 'PV1 Voltage',
    pv1Current: 'PV1 Current',
    pv1Power: 'PV1 Power',
    outputVoltage: 'Output Voltage',
    outputCurrent: 'Output Current',
    outputPower: 'Output Power',
    outputFrequency: 'Output Frequency',
    photovoltaic: 'Photovoltaic',
    energyStorage: 'Energy Storage',
    powerGrid: 'Power Grid',
    load: 'Load',
    pv: 'PV',
    inverterAnalysis: 'Inverter Analysis',
    inverterData: 'Inverter Data',
    statisticReport: 'Statistic Report',
    reportType: 'Report Type',
    pvModule: 'PV Module',
    noData: 'No Data',
    pvModuleReg: 'Please select PV module',
    timeReg: 'Please select time',
    saveAsImage: 'Save as Image',
    exportXlsx: 'Export Xlsx',
    dashboard: 'Dashboard',
    layoutDesign: 'Layout Design',
    overview: 'Overview',
    physicalLayout: 'Physical Layout',
  },
  firmware: {
    firmwareName: 'Firmware Name',
    firmwareList: 'Firmware List',
    version: 'Version',
    versionPlaceHolder: 'Hardware or firmware version',
    firmware: 'Firmware',
    firmwareUpload: 'Firmware Upload',
    uploadFail: 'Upload Fail',
    firmwareReg: 'Please select firmware',
    upload: 'Upload',
    fileSize500M: 'File size cannot exceed 500M',
    firmwareExist: 'Firmware already exist',
    firmwareNameNotify: 'The firmware file name prefix xx_V0.0.0~xx_V255.255.255, xx must be several characters containing letters or numbers or - or _, and the suffix must be .bin or .hex',
    firmwareNameEndReg: 'The firmware file name must end with .bin or .hex',
    firmwareNameCorrectReg: 'Please select the correct firmware file, with the file name prefix xx_V0.0.0~xx_V255.255.255, xx must be several characters containing letters or numbers or - or _',
    firmwareNameExceed: 'Firmware file name exceeds 64 characters',
    firmwareType: 'Firmware Type',
    firmwareTypeReg: 'Please select firmware type',
    firmwareTypeRepeatedReg: 'The firmware type XXX is repeated',
  },
  grid: {
    gridProfile: 'Grid Profile',
    gridConfigurationManagement: 'Grid Configuration Management',
    profileName: 'Profile Name',
    name: 'Name',
    value: 'Value',
    unit: 'Unit',
    range: 'Range',
    profileNameReg: 'Please enter profile name',
    versionReg: 'Please enter version',
    versionCorrectReg: 'Please enter the correct version, V0.0.0 ~ V999.999.999',
    leading: 'Leading',
    lagging: 'Lagging',
    StdCNVol: '交流侧电压 。标准并网电。',
    StdCLv1: '第一交流侧欠压保护值。第一段输出低压保护值。',
    StdCLv1Mtt: '达到LV1之后，断开电网的时间。',
    StdCHv1: '第一交流侧过压保护值。第一段输出高压保护值。',
    StdCHv1Mtt: '达到HV1之后，断开电网的时间。',
    StdCLv2: '第二交流侧欠压保护值。第二段输出低压保护值。',
    StdCLv2Mtt: '达到LV2之后，断开电网的时间。',
    StdCHv2: '第二交流侧过压保护值。第二段输出过压保护值。',
    StdCHv2Mtt: '达到HV2之后，断开电网的时间。',
    StdCNFre: '并网频率',
    StdCLf1: '最低频率保护点',
    StdCLf1Mtt: '达到最低保护点后的离网保护时间',
    StdCHf1: '最高频率保护点',
    StdCHf1Mtt: '达到最高保护点后的离网保护时间',
    StdCIdEn: '孤岛保护触发标志位',
    StdCRt: '掉电保护之后的重新连接时间',
    StdCRhv: '掉电保护之后重新连接的最大电压',
    StdCRlv: '掉电保护之后重新连接的最小电压',
    StdCRhf: '掉电保护之后重新连接的最大频率',
    StdCRlf: '掉电保护之后重新连接的最小频率',
    StdCRurNm: '正常并网情况下，逆变器输出功率的上升斜率',
    StdCRurSs: '保护后重新连接时，逆变器输出功率的上升斜率',
    StdCFwEn: '输出有功功率根据频率变化功能的标识位',
    StdCFwFstart: '开始降功率的电网频率',
    StdCFwDSlope: '功率下降的斜率',
    StdCFwSss: '功率恢复的斜率',
    StdCApcEn: '输出有功功率控制可以直接通过监控平台下发命令实现，该功能默认开启。同时，本模块中也支持逆变器输出有功功率变化率的修改。',
    StdCSpfEn: 'SPF功能使能标志位',
    StdCSpfLeadLag: '允许运行的功率因数设置',
    StdCVwEn: '输出功率根据输出电压变化功能的使能标志位',
    StdCVwVStart: '功率开始下降的输出电压值',
    StdCVwVEnd: '功率不再下降的输出电压值',
    StdCVwKPower: '本功能下，功率下降的斜率',
    StdCCosEn: 'Cosφ(P) 测试项目使能',
    StdCCosPwPt1: '第一个测试点的功率值百分比',
    StdCCosPwPt2: '第二个测试点的功率值百分比',
    StdCCosPwPt3: '第三个测试点的功率值百分比',
    StdCCosPfPt1: '第一测试点时的PF',
    StdCCosPfPt2: '第二测试点时的PF',
    StdCCosPfPt3: '第三测试点时的PF',
    StdCOptEn: '10分钟过压保护功能使能开关',
    StdCOptVol: '10分钟过压保护时的设定电压值',

    'H/LVRT': 'The generating plant shall not disconnect due to changes in grid voltage when the voltage at the point of connection stays within the normal range, such as 0.85*Un to 1.1Un. At the same time, the plant should be disconnected from the distribution network after the required time if the grid voltage is beyond this normal range. This required time is defined as the “Maximum Trip Time” and the upper and lower ranges of grid voltage are defined as “Low Voltage” or “High Voltage”, respectively. Users can adjust these parameters according to the requirements of local regulatory authorities.',
    'H/LFRT': 'The generating plant shall be capable of operating continuously when the grid frequency at the point of connection stays within the normal range. The plant should be disconnected from the distribution network after the required time if the grid frequency is beyond this normal range. Similar to the H/LVRT module, this required time is defined as the “Maximum Trip Time” and the upper and lower ranges of grid frequency are defined as “Low Frequency” or “High Frequency”, respectively. Users can adjust these parameters according to the requirements of local regulatory authorities.',
    IslandingDetection: 'Islanding is where a section of the electricity network containing the PV plant becomes physically disconnected from the rest of the power system. The inverters shall be capable of detecting this islanding situation and stop generating electricity. This function is enabled by default and adjustments are not recommended.',
    Reconnection: 'When the grid voltage and frequency are abnormal, the PV inverters should not be generating electricity. However, when the grid voltage and frequency are within the allowed range, the inverters are allowed to connect and start generating electricaity. The settings for the connections can be set in the Reconnection module and Ramp Rate module. The frequency range, voltage range and reconnection time can be modified in the Reconnection module while the power gradient can be set in the Ramp Rate module. Please note the settings here are for whether the inverter starts normally or is automatically reconnected after the interface protection trips. In the Ramp Rate module, "Normal Ramp up Rate (RUR_NM)" is used for normal operations and normal starting of the inverter, and "Soft Start Ramp up" Rate (RUR_SS)" is used to automatically reconnect after the interface protection trips. Users can adjust these parameters according to the requirements of local regulatory authorities.',
    RampRates: 'When the grid voltage and frequency are abnormal, the PV inverters should not be generating electricity. However, when the grid voltage and frequency are within the allowed range, the inverters are allowed to connect and start generating electricaity. The settings for the connections can be set in the Reconnection module and Ramp Rate module. The frequency range, voltage range and reconnection time can be modified in the Reconnection module while the power gradient can be set in the Ramp Rate module. Please note the settings here are for whether the inverter starts normally or is automatically reconnected after the interface protection trips. In the Ramp Rate module, "Normal Ramp up Rate (RUR_NM)" is used for normal operations and normal starting of the inverter, and "Soft Start Ramp up" Rate (RUR_SS)" is used to automatically reconnect after the interface protection trips. Users can adjust these parameters according to the requirements of local regulatory authorities.',
    FrequencyWatt: 'The Frequency Watt module is used to adjust the response of the inverter\'s active output power to the grid frequency. The figure below is the curve diagram corresponding to the function of this module. When the output grid voltage frequency of the photovoltaic inverter is higher than Fstart, the output power of the inverter will decrease with the slope Kpower_Freq.\n'
      + 'Users can adjust these parameter values according to the requirements of local regulatory authorities.',
    ActivePowerControl: 'The output active power can be directly limited using commands from the monitoring platform. This function is enabled by default. The change rate of the output active power can be also modified in this module.',
    SpecifiedPowerFactor: 'The Volt Var, SPF, WPF and RPC modules are all related to the Reactive Power Control. For the microinverter which supports Reactive Power Control, all these modules will be disabled by default and only one of them can be enabled at a time.\n'
      + '\n'
      + 'In some cases, the inverter needs to set a specified power factor to meet local requirements. The maximum range of the fixed power factor settings supported by the micro-inverter is 0.8, resulting in 0.8 lag.\n'
      + '\n'
      + 'Note 1: The power factor is the ratio of the absolute value of the active power P to the apparent power S under periodic conditions.\n'
      + 'Note 2: The lagging power factor is defined to be when the inverter acts as an inductive load from the perspective of the grid. The Leading power factor is defined to be when the inverter acts as a capacitive load from the perspective of the grid.\n'
      + 'Note 3: If the user would like to set the power factor to be 0.95 leading, the user should select Leading in this module and set the value to 0.95.',
    VoltWatt: 'The Volt Watt module varies the output power of the inverter in response to the voltage at the point of connection. When the grid voltage is higher than Vstart, output power goes down at the Kpower_Volt slope shown below. Users can adjust these parameters according to the requirements of local regulatory authorities.',
    CosCurve: '',
    currentUsage: 'Current Usage',
    sysConfigure: 'System Configuration',
    userConfigure: 'User Configuration',
    distributeGridProfile: 'Do you want to distribute the current grid profile ',
    deleteCurrentUseProfile: '<strong style="color: #606266">XXX</strong> is currently in use in the <strong style="color: #606266">YYY</strong>. Deleting it will cause updates to the grid profile of all plant in that country or region. Are you sure you want to delete it?',
  },
  errorPage404: {
    errorInfo: 'Please check that the URL you entered is correct, or click the button below to return to the homepage.',
    returnHome: 'Back to home',
  },
  common: {
    default: 'Default',
    creationTime: 'Creation Time',
    updateTime: 'Update Time',
    operation: 'Operation',
    installationTime: 'Installation Time',
    ratedPower: 'Capacity(W)',
    powerw: 'Power(W)',
    search: 'Search',
    export: 'Export',
    number: 'NO.',
    clear: 'Clear',
    time: 'Time',
    keyword: 'Keyword',
    add: 'Add',
    kw: 'kW',
    mwh: 'MWh',
    kwh: 'KWh',
    w: 'W',
    v: 'V',
    a: 'A',
    celsiusDegree: '℃',
    var: 'Var',
    kVarh: 'KVarh',
    hz: 'Hz',
    percentSign: '%',
    va: 'VA',
    voltage: 'Voltage',
    current: 'Current',
    power: 'Power',
    yield: 'Produced',
    sure: 'Confirm',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    save: 'Save',
    addSuccess: 'Add Successfully',
    editSuccess: 'Edit Successfully',
    deleteSuccess: 'Delete Successfully',
    resetSuccess: 'Reset Successfully',
    createSuccess: 'Create Successfully',
    updateSuccess: 'Update Successfully',
    uploadSuccess: 'Upload Successfully',
    saveSuccess: 'Save Successfully',
    setSuccess: 'Set Successfully',
    setFailed: 'Set Failed',
    setTimeout: 'Set Timeout',
    commandResponseFailed: 'Command Response Failed',
    issuedSuccess: 'Issued Successfully',
    canceledSuccessfully: 'Canceled Successfully',
    deliveredSuccess: 'Delivered Successfully',
    unbindSuccess: 'Unbind Successfully',
    yes: 'Yes',
    no: 'No',
    detail: 'Detail',
    remind: 'Remind',
    sureDelete: 'Are you sure you want to delete ',
    sureDisassociation: 'Are you sure you want to disassociation ',
    sureUnbind: 'Are you sure you want to unbind ',
    pleaseSelect: 'Select',
    comment: 'Comment',
    status: 'Status',
    bathImportSuccess: 'Bath Import Successfully',
    back: 'Back',
    send: 'Send',
    second: 'Second',
    version: 'Version',
    dataEmpty: 'Data is empty',
    commaSymbol: ',',
    spaceSymbol: ' ',
    copySuccess: 'Copy Successfully',
    mac: 'MAC',
    pleaseEnterReg: 'Please enter',
    greaterThanOrEqualToZeroReg: 'Greater than or equal to 0',
    greaterThan0: 'Greater than 0',
    numberReg: 'must be numeric',
    leftBracket: '(',
    rightBracket: ')',
    showColumns: 'Show Columns',
    forceDeleteRemind: 'whether to force deletion?',
    questionMarkSymbol: '?',
    submit: 'Submit',
    upgrade: 'Upgrade',
    cancelUpgrade: 'Cancel Upgrade',
    sureCancelUpgrade: 'Are you sure you want to cancel upgrade',
    finish: 'Finish',
    done: 'Done',
    close: 'Close',
    nextStep: 'Next',
    previousStep: 'Previous',
    sureUpgrade: 'Are you sure you want to upgrade the firmware of xxx',
    sureUpgradePlant: 'Are you sure you want to upgrade all microinverter, gateway, and power conversion system devices under xxx',
    hour: 'Hour',
    minute: 'Minute',
    runTime: 'Run Time',
    upgradeTime: 'Upgrade Time',
    batchCancel: 'Batch Cancel',
    cannotBeEmpty: 'can\'t be empty',
    debug: 'Start Debug',
    restart: 'Restart',
    restoreFactorySettings: 'Restore Factory Settings',
    oneClickCancel: 'Cancel the microinverter upgrade with one click',
    upgradeCanceled: 'Upgrade Canceled',
    upgradeSuccessfully: 'Upgrade Successfully',
    upgradeFailed: 'Upgrade Failed',
    valueError: 'Value Error',
    enterRange: 'Range',
    instructions: 'Instructions',
    ok: 'OK',
    lowerLimit: 'lowerLimit',
    upperLimit: 'upperLimit',
    lowerLimitCorrectReg: 'greater than the upper limit',
    upperLimitCorrectReg: 'less than the lower limit',
    invalidInput: 'Invalid Input',
    moreOperations: 'More Operations',
    colon: ':',
    multipleSelect: 'Multiple Select',
    websiteSettings: 'Website Settings',
    uploadImageFile: 'Please upload a file in image format',
  },
  time: {
    paceSymbol: ' ',
    year: 'Y',
    day: 'D',
    hour: 'H',
    minute: 'Min',
    second: 'S',
  },
  defines: {
    admin: 'Admin',
    agency: 'Agency',
    installer: 'Installer',
    user: 'User',
    inverter: 'Microinverter',
    gateway: 'Gateway',
    meter: 'Meter',
    pcs: 'Power Conversion System',
    notDelivered: 'Undeliverd',
    leaveTheFactory: 'Deliverd',
    installed: 'Installed',
    underMaintenance: 'In maintenance',
    scrap: 'Scrap',
    normal: 'Normal',
    faulty: 'Faulty',
    offline: 'Offline',
    online: 'Online',
    EbatInA: 'EbatInA',
    EbatInT: 'EbatInT',
    EbatOutA: 'EbatOutA',
    EbatOutT: 'EbatOutT',
    EepsInA: 'EepsInA',
    EepsOutA: 'EepsOutA',
    EgridInA: 'EgridInA',
    EgridInT: 'EgridInT',
    EgridOutA: 'EgridOutA',
    EgridOutT: 'EgridOutT',
    EpvA: 'EpvA',
    EpvT: 'EpvT',
    EqGridInA: 'EqGridInA',
    EqGridInT: 'EqGridInT',
    EqGridOutA: 'EqGridOutA',
    EqGridOutT: 'EqGridOutT',
    Fac: 'Fac',
    Iac: 'Iac',
    Idc: 'Idc',
    PFac: 'PFac',
    Pac: 'Pac',
    Pdc: 'Pdc',
    Qac: 'Qac',
    Sac: 'Sac',
    StError: 'StError',
    StFunc: 'StFunc',
    StMode: 'StMode',
    StRuntime: 'StRuntime',
    StWork: 'StWork',
    TEepsInA: 'TEepsInA',
    TEepsOutA: 'TEepsOutA',
    TEgridInA: 'TEgridInA',
    TEgridInT: 'TEgridInT',
    TEgridOutA: 'TEgridOutA',
    TEgridOutT: 'TEgridOutT',
    TEqGridInA: 'TEqGridInA',
    TEqGridInT: 'TEqGridInT',
    TEqGridOutA: 'TEqGridOutA',
    TEqGridOutT: 'TEqGridOutT',
    TPFac: 'TPFac',
    TPac: 'TPac',
    TQac: 'TQac',
    TSac: 'TSac',
    Tbat: 'Tbat',
    Tc: 'Tc',
    Tinv: 'Tinv',
    Tpv: 'Tpv',
    Vac: 'Vac',
    Vdc: 'Vdc',
    dispose: 'Processed',
    undisposed: 'Unprocessed',
    unrecovered: 'Processing',
    hint: 'Notice',
    warning: 'Caution',
    error: 'Warning',
    fatal: 'Danger',
    minutes1: '1 minutes',
    minutes5: '5 minutes',
    minutes10: '10 minutes',
    minutes15: '15 minutes',
    otaModeAll: 'Upgrade together',
    otaModeSingle: 'Upgraded one by one',
    otaModeBathch: 'Batch upgrade',
  },
  currency: {
    Euro: 'Euro',
    USD: 'United States Dollar',
    RMB: 'Chinese Yuan',
    GBP: 'British Pound',
    AUD: 'Australia Dollar',
    INR: 'Indian Rupee',
    NZD: 'New Zealand Dollar',
    THB: 'Thai Baht',
    BRL: 'Brazilian real',
    PLN: 'Polish zlote',
    PHP: 'Philippine Peso',
  },
  pcs: {
    operatingMode: 'Operating mode',
    selfPowered: 'Self-Powered',
    selfPowereddetail: 'Prioritize the use of solar for your home and charge battery with excess solar during the day.',
    reserveSOC: 'Reserve SOC',
    feedin: 'Feed-in Power Percentage',
    timeBase: 'Time-based Control',
    timeBaseDetial: 'Use this mode if your energy rates vary throughout the day.',
    backUp: 'Back Up',
    backUpSOC: 'Back-up Reserve SOC',
    offGridSOC: 'Off-grid Reserve SOC',
    backUpDetail: 'Battery stays at setting charge level so that you have reserve backup at all times.',
    charging: 'Charging',
    discharging: 'Discharging',
    exportingBattery: 'Exporting Battery Energy to Grid',
    time: 'Charging/Discharging Time',
    addTime: 'Add time period',
    startTimeReg: 'Please select start time',
    endTimeReg: 'Please select end time',
    startTime: 'Start Time',
    endTime: 'End Time',
    sTimeeTimeReg: 'The start and end times can\'t both be 00:00',
    timeOverlapReg: 'Time overlap',
  },
  instruction: {
    deviceDebugging: 'Device Debugging',
    instruction: 'Instruction',
    instructionName: 'Instruction Name',
    instructionCount: 'Instruction Count',
    operator: 'Operator',
    subcommand: 'Subcommand',
    startBit: 'Start Bit',
    outputBit: 'Output BIT',
    control: 'Control Command',
    add: 'Add',
    readLen: 'Read Length',
    writeLen: 'Write Length',
    writeByteLen: 'Write Byte Length',
    writeDatas: 'Write Datas',
    command: 'Command',
    send: 'Send',
    sendTime: 'send/receivingTime',
    data: 'Data',
  },
};
